export enum CompareMethodKeyEnum {
    Cumulative = "cumulative",
    Normalized = "normalized",
}
